import React from "react";

export default function Status() {
  return (
    <section id="status">
      <div className="row status" data-aos="fade-up" data-aos-anchor=".skills" data-aos-offset="800" data-aos-duration="1700">
        <h1>
          <span>Military status:</span>
          <span>Final exempted</span>
        </h1>
        <h1>
          <span>Marital status:</span>
          <span>Married</span>
        </h1>
      </div>
    </section>
  );
}
